function oxfordCommaJoin(arr) {
    if (arr.length === 1) return arr[0];
    const firsts = arr.slice(0, arr.length - 1);
    const last = arr[arr.length - 1];
    return `${firsts.join(", ")} and ${last}`;
}

function isValidFirebaseKey(text) {
    return (
        typeof text === "string" && text.length && !text.match(/[.$\[\]#\/]/) && text.length <= 768
    );
}

function isFullUrl(url) {
    if (!url) return false;
    return url.startsWith("http://") || url.startsWith("https://");
}

module.exports = { oxfordCommaJoin, isValidFirebaseKey, isFullUrl };
